import * as array from 'd3-array'
import * as scale from 'd3-scale'
import * as util from 'infographic-util'
import * as d3 from 'd3-selection'
import container from './container'
import {layout} from './container'
import gradients from './gradients'

import basic from './animations/basic-animation'

export const animations = [
  basic
]

/*
 * This builds a path of the outer funnel shape. The path is used
 * to build a clip path so inner components don't exceed the bounds of the
 * funnel. The outer arc is also used to determine where to draw each
 * of the inner shapes.
 */
const funnelPath = dimensions => {
  let center = dimensions.center
    , width = dimensions.width / 2
    , height = dimensions.height
    , control0Offset = height * .05
    , control1X = center * .45
    , control1Y = height * .25

  return [
    `M ${center - width}, 0`,
    `C ${center - width}, ${control0Offset}
       ${control1X}, ${control1Y}
       ${center - dimensions.bottomWidth / 2}, ${height}`,
    `a ${dimensions.bottomWidth / 2},${dimensions.bottomWidth * layout.topCX / 2} 0 1,0 ${dimensions.bottomWidth},0`,
    `C ${dimensions.width - control1X}, ${control1Y}
      ${dimensions.width}, ${control0Offset}
      ${dimensions.width}, 0`,
    `a ${dimensions.width / 2},${dimensions.width / 2 * layout.topCX} 0 1,0 ${-dimensions.width},0`
  ]
}


export const preAnimate = function (chart, selection, series) {
  let seriesData = series.selection().data()
    , dimensions = chart.datum().dimensions
    , grid = chart.layout.getGrid(dimensions)
    , config = chart.datum().axes.infographic
    , defs = d3.select(chart.node().ownerSVGElement).selectAll('defs')

  let paddingPercentage = .1
    , totalWidth = grid.width

  if (grid.width / grid.height > 9 / 6) {
    // Restrict the aspect ratio to 9:6
    totalWidth = grid.height * 1.5
  }

  let bottomWidth = totalWidth * .45
    , bottomPadding = bottomWidth * .10 // 10% of the bottom width
    , topPadding = totalWidth * .0825 // 8.25% of the width
    , maxPadding = bottomWidth * layout.topCX / 2
    , padScale = scale.scaleBand()
                      .domain([0, seriesData.length - 1])
                      .range([0, grid.height])
                      .paddingInner(paddingPercentage)
    , padding = Math.min(padScale.step() - padScale.bandwidth(), maxPadding)
    , totalHeight = grid.height - padding * (seriesData.length - 1) - bottomPadding - topPadding
    , colors = new Set


  let sliceY = percentage => {
    return (-totalWidth + Math.sqrt(totalWidth * totalWidth + (bottomWidth  * bottomWidth - totalWidth * totalWidth) * percentage))
      * totalHeight / (bottomWidth - totalWidth)
  }

  let sliceWidth = bottom => {
    return totalWidth + bottom / totalHeight * (bottomWidth - totalWidth)
  }

  let funnels = grid.blocks.map(block => {
    let points = util.getStackedPoints(config, totalHeight, block, seriesData, padding, sliceY, sliceWidth, false)

    points.forEach(point => {
      colors.add(point.color)
    })

    return {
      dimensions: {
        padding,
        width: totalWidth,
        bottomWidth,
        height: grid.height - topPadding - bottomPadding,
        center: totalWidth / 2,
        topPadding,
        bottomPadding
      },
      block,
      padding,
      points: points
    }
  })

  // Add the gradients
  defs.call(gradients, Array.from(colors), chart.defaultTransition)

  let outline = funnelPath(funnels[0].dimensions)
    , clip = defs.selectAll(`clipPath#${chart.id}-funnel-clip`)
                 .data(d => [d])

  clip.enter()
      .append('clipPath')
      .attr('id', `${chart.id}-funnel-clip`)
      .append('path')
      .merge(clip.selectAll('path'))
      .attr('d', outline.join(' '))

  selection.call(container, chart, funnels, outline, config)

}
